import React from 'react';
import { Grid } from 'semantic-ui-react';

const Chat = () => (
  <Grid style={{ margin: 30 }} divided>
    <Grid.Column width={6}>
      <p>applications go here</p>
    </Grid.Column>
    <Grid.Column stretched width={10} style={{ border: '1px solid pink' }}>
      <h1>chat goes here</h1>

      <iframe width="100%;" height="100%" src="https://chat.dyzio.co/blah?layout=embedded" />

    </Grid.Column>
  </Grid>
);

export default Chat;



/** WEBPACK FOOTER **
 ** ./src/containers/chat/index.js
 **/